import { SCREEN_SIZE } from 'types';
interface ActionTypes {
  SET_USER_SESSION: string;
  SET_AUTHENTICATED: string;
  SESSION_START: string;
  SESSION_END: string;
  SET_SCREEN_SIZE: string;
  SET_BASE_MAP: string;
  SET_ACTIVATE_IDLE: string;
  SET_SYSADMIN_MODE: string;
  ADD_ALERT: string;
  REMOVE_ALERT: string;
  REMOVE_ALL_ALERTS: string;
  ADD_NOTIFICATION: string;
  REMOVE_NOTIFICATION: string;
  FETCH_USER_START: string;
  FETCH_USER_SUCCESS: string;
  FETCH_USER_FAILURE: string;
  UPDATE_USER_START: string;
  UPDATE_USER_SUCCESS: string;
  UPDATE_USER_FAILURE: string;
  AUTHENTICATION_START: string;
  AUTHENTICATION_SUCCESS: string;
  AUTHENTICATION_FAILURE: string;
  LOAD_CUSTOM_BASEMAP_START: string;
  LOAD_CUSTOM_BASEMAP_SUCCESS: string;
  LOAD_CUSTOM_BASEMAP_FAILURE: string;
  MAILBOX_UNMATCHED_COUNT_START: string;
  MAILBOX_UNMATCHED_COUNT_SUCCESS: string;
  MAILBOX_UNMATCHED_COUNT_FAILURE: string;
  SET_MAINTENANCE: string;
  TOGGLE_SHOW_HIDE: string;
  SHOW_ORGANISATION_SUSPENDED_MODAL: string;
  FETCH_ALERT_NOTIFICATION_STATUS_START: string;
  FETCH_ALERT_NOTIFICATION_STATUS_SUCCESS: string;
  FETCH_ALERT_NOTIFICATION_STATUS_FAILURE: string;
}

export const SessionActionTypes: ActionTypes = {
  SESSION_START: '@@SET_START_SESSION',
  SESSION_END: '@@SET_END_SESSION',
  SET_AUTHENTICATED: '@@SET_AUTHENTICATED',
  SET_USER_SESSION: '@@SET_USER_SESSION',
  SET_SCREEN_SIZE: '@@SET_SCREEN_SIZE',
  SET_BASE_MAP: '@@SET_BASE_MAP',
  SET_ACTIVATE_IDLE: '@@SET_ACTIVATE_IDLE',
  SET_SYSADMIN_MODE: '@@SET_SYSADMIN_MODE',
  ADD_ALERT: '@@ADD_ALERT',
  REMOVE_ALERT: '@@REMOVE_ALERT',
  REMOVE_ALL_ALERTS: '@@REMOVE_ALL_ALERTS',
  ADD_NOTIFICATION: '@@ADD_NOTIFICATION',
  REMOVE_NOTIFICATION: '@@REMOVE_NOTIFICATION',
  FETCH_USER_START: '@@FETCH_USER_START',
  FETCH_USER_SUCCESS: '@@FETCH_USER_SUCCESS',
  FETCH_USER_FAILURE: '@@FETCH_USER_FAILURE',
  UPDATE_USER_START: '@@UPDATE_USER_START',
  UPDATE_USER_SUCCESS: '@@UPDATE_USER_SUCCESS',
  UPDATE_USER_FAILURE: '@@UPDATE_USER_FAILURE',
  AUTHENTICATION_START: '@@AUTHENTICATION_START',
  AUTHENTICATION_SUCCESS: '@@AUTHENTICATION_SUCCESS',
  AUTHENTICATION_FAILURE: '@@AUTHENTICATION_FAILURE',
  LOAD_CUSTOM_BASEMAP_START: '@@LOAD_CUSTOM_BASEMAP_START',
  LOAD_CUSTOM_BASEMAP_SUCCESS: '@@LOAD_CUSTOM_BASEMAP_SUCCESS',
  LOAD_CUSTOM_BASEMAP_FAILURE: '@@LOAD_CUSTOM_BASEMAP_FAILURE',
  MAILBOX_UNMATCHED_COUNT_START: '@@AMAILBOX_UNMATCHED_COUNT_START',
  MAILBOX_UNMATCHED_COUNT_SUCCESS: '@@MAILBOX_UNMATCHED_COUNT_SUCCESS',
  MAILBOX_UNMATCHED_COUNT_FAILURE: '@@MAILBOX_UNMATCHED_COUNT_FAILURE',
  SET_MAINTENANCE: '@@SET_MAINTENANCE',
  TOGGLE_SHOW_HIDE: '@@TOGGLE_SHOW_HIDE',
  SHOW_ORGANISATION_SUSPENDED_MODAL: '@@SHOW_ORGANISATION_SUSPENDED_MODAL',
  FETCH_ALERT_NOTIFICATION_STATUS_START:
    '@@FETCH_ALERT_NOTIFICATION_STATUS_START',
  FETCH_ALERT_NOTIFICATION_STATUS_SUCCESS:
    '@@FETCH_ALERT_NOTIFICATION_STATUS_SUCCESS',
  FETCH_ALERT_NOTIFICATION_STATUS_FAILURE:
    '@@FETCH_ALERT_NOTIFICATION_STATUS_FAILURE'
};

export interface SessionState {
  session: boolean;
  initial?: boolean;
  isAuthenticated?: boolean;
  currentUser?: any;
  sessionExpiryIn?: number;
  screenSize?: SCREEN_SIZE;
  userProcess?: 'loading' | 'updating' | 'deleting' | 'refetch';
  authenticing?: boolean;
  authError?: Error;
  baseMap?: BaseMapObject;
  customBaseMap?: any;
  alerts: any[];
  notifications: { id: string; data: any }[];
  activateIdle?: boolean;
  mailboxUnmatchedCount?: number;
  isSysAdminMode?: boolean;
  isMaintenance?: boolean;
  isShowHideTriggered: boolean;
  showOrganisationSuspendedModal?: boolean;
  isEnvVar?: boolean;
  appConfig?: any;
}

export type BaseMapObject = {
  id: string;
  fromPortal: boolean;
  theme: 'light' | 'dark';
  isCustom: boolean;
};
